import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Button from 'components/Button';

import './ActiveWithdrawalRequestsItem.scss';

const b = block('active-withdrawal-requests-item');

const ActiveWithdrawalRequestsItem = ({ item, onReject, currency, onAreYouSure }) => {
  const locale = useSelector(state => state.locale.locale);
  const { channelHolder } = useSelector(state => state.auth);

  return (
    <section className={b()}>
      <div className={b('item')}>
        <div className={b('item-text')}>{locale.transactionId}</div>
        <div className={b('item-value')}>{item.id}</div>
      </div>

      <div className={b('item')}>
        <div className={b('item-text')}>{locale.date}</div>
        <div className={b('item-value', { date: true })}>{item.date}</div>
      </div>

      {channelHolder && (
        <div className={b('item')}>
          <div className={b('item-text')}>{locale.playerId}</div>
          <div className={b('item-value', { strictSplit: true })}>{item.playerId}</div>
        </div>
      )}

      {!channelHolder && (
        <div className={b('item')}>
          <div className={b('item-text')}>{locale.playerId}</div>
          <div className={b('item-value')}>{item.userId}</div>
        </div>
      )}

      <div className={b('item')}>
        <div className={b('item-text')}>{locale.paymentNumber}</div>
        <div className={b('item-value', { strictSplit: true })}>{item?.paymentNumber}</div>
      </div>

      <div className={b('item')}>
        <div className={b('item-text')}>{locale.amount}</div>
        <div className={b('item-value', { red: true })}>
          <span>{item.amount}</span>
        </div>
      </div>

      <div className={b('button')}>
        <div className={b('center')}>
          <Button color="transparent" onClick={() => { onReject(); onAreYouSure('sureReject') }}>
            <span className={b('button-text', { red: true })}>{locale.reject}</span>
          </Button>
        </div>
      </div>

      <div className={b('button')}>
        <div className={b('center')}>
          <Button onClick={() => { onReject(); onAreYouSure('sureWithdrawal') }}>
            <span className={b('button-text')}>{locale.confirm}</span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ActiveWithdrawalRequestsItem;
